import ENV from "~/constants";
import {
  type Configuration,
  PublicClientApplication,
  LogLevel,
} from "@azure/msal-browser";

const clientId = ENV.REACT_APP_AD_CLIENT_ID;
const tenantId = ENV.REACT_APP_AD_TENANT_ID;

export const loginRequest = {
  scopes: ["openid", "offline_access"],
};

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      piiLoggingEnabled: false,
    },
    navigateFrameWait: 2000,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
